export default __webpack_public_path__ + "static/media/geardm.8554bde4.svg";